import './Navbar.css';
import React, { useState } from 'react';
function Navbar({ onToggleCart }) {

    const [isMenuVisible, setMenuVisibility] = useState(false);

    const toggleMenuVisibility = () => {
        setMenuVisibility(prevState => !prevState);
    };
    return (
        <nav className='navbar'>
            <div className='nav-items'>
                <ul className='nav-list-left nav-list'>
                    <li key="home"><a href='#'>HOME</a></li>
                    <li key="products"><a href='#products'>PRODUCTS</a></li>
                    
                </ul>
                <div className='nav-image'>
                    <a href='#'><p className='site-icon-text'>LaptopZone</p></a>
                </div>
                <ul className='nav-list-right nav-list'>
                    <li key="cart"><a href='#blog'>BLOG</a></li>
                    <li onClick={onToggleCart} key="cart"><a>CART</a></li>
                </ul>
                <div id='nav-btn-div'>
                    <button onClick={toggleMenuVisibility} className='nav-btn'><a><i class="fa-solid fa-bars"></i></a></button>
                </div>
            
                
            </div>

            {isMenuVisible && (
                <div id='nav-btn-menu'>
                    <ul className='nav-menu-list pt-3 pb-2'>
                        <li key="home"><a href='#'>HOME</a></li>
                        <hr/>
                        <li key="products"><a href='#products'>PRODUCTS</a></li>
                        <hr/>
                        <li key="cart"><a href='#blog'>BLOG</a></li>
                        <hr/>
                        <li onClick={onToggleCart} key="cart"><a>CART</a></li>
                        <hr/>
                    </ul>
                </div>
            )}
            
        </nav>
    )
}

export default Navbar;
